import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row flex-wrap"
}
const _hoisted_3 = { class: "col-12 xl:col-7" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "fluid grid" }
const _hoisted_6 = { class: "field col-12" }
const _hoisted_7 = {
  key: 0,
  class: "pi pi-lock"
}
const _hoisted_8 = {
  key: 1,
  class: "pi pi-lock-open"
}
const _hoisted_9 = {
  key: 0,
  class: "float-right label"
}
const _hoisted_10 = { autocomplete: "off" }
const _hoisted_11 = { class: "field col-12" }
const _hoisted_12 = { autocomplete: "off" }
const _hoisted_13 = { class: "field col-12" }
const _hoisted_14 = { class: "flex flex-nowrap" }
const _hoisted_15 = {
  key: 0,
  class: "field col-12"
}
const _hoisted_16 = {
  key: 1,
  class: "field col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[17] || (_cache[17] = _createElementVNode("h3", null, null, -1)),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enableNameEdit && _ctx.enableNameEdit(...args)))
                        }, [
                          (_ctx.nameLocked)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                            : _createCommentVNode("", true),
                          (!_ctx.nameLocked)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                            : _createCommentVNode("", true)
                        ]),
                        (!this.newUser)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "# " + _toDisplayString(_ctx.loginId), 1))
                          : _createCommentVNode("", true),
                        _cache[8] || (_cache[8] = _createElementVNode("label", null, "Login Email", -1)),
                        _createElementVNode("form", _hoisted_10, [
                          _createVNode(_component_InputText, {
                            modelValue: _ctx.userRecord.loginEmail,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userRecord.loginEmail) = $event)),
                            modelModifiers: { trim: true },
                            disabled: _ctx.nameLocked
                          }, null, 8, ["modelValue", "disabled"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", null, "Login Password", -1)),
                        _cache[10] || (_cache[10] = _createTextVNode()),
                        _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("form", _hoisted_12, [
                          _createVNode(_component_InputText, {
                            modelValue: _ctx.password,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                            modelModifiers: { trim: true },
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.passwordChanged = true))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _cache[14] || (_cache[14] = _createElementVNode("label", null, "Access Roles", -1)),
                        _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ToggleButton, {
                            modelValue: _ctx.userRecord.isCompassStaff,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userRecord.isCompassStaff) = $event)),
                            onLabel: "Compass Staff",
                            offLabel: "Compass Staff",
                            onChange: _ctx.onAccessRoleChange
                          }, null, 8, ["modelValue", "onChange"]),
                          _cache[12] || (_cache[12] = _createTextVNode("   ", -1)),
                          _createVNode(_component_ToggleButton, {
                            modelValue: _ctx.userRecord.isExternalCustomer,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userRecord.isExternalCustomer) = $event)),
                            onLabel: "External Customer",
                            offLabel: "External Customer",
                            onChange: _ctx.onAccessRoleChange
                          }, null, 8, ["modelValue", "onChange"]),
                          _cache[13] || (_cache[13] = _createTextVNode("   ", -1)),
                          _createVNode(_component_ToggleButton, {
                            modelValue: _ctx.userRecord.isExternalSupplier,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userRecord.isExternalSupplier) = $event)),
                            onLabel: "External supplier",
                            offLabel: "External Supplier",
                            onChange: _ctx.onAccessRoleChange
                          }, null, 8, ["modelValue", "onChange"])
                        ])
                      ]),
                      (!_ctx.newUser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _cache[16] || (_cache[16] = _createElementVNode("label", null, "Last login", -1)),
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.formattedLastLoginDateTime,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formattedLastLoginDateTime) = $event)),
                              disabled: true
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.newUser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_Button, {
                              class: "float-right",
                              label: "Delete Login",
                              onClick: _ctx.deleteLogin
                            }, null, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          class: "sticky-button cancel",
          icon: "pi pi-times",
          label: _ctx.hasChanges ? 'Cancel' : 'Close',
          onClick: _ctx.cancel
        }, null, 8, ["label", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.$store.getters.isInternalUser)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (!_ctx.loading && !_ctx.newUser)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "sticky-button",
                icon: "pi pi-check",
                label: "Save",
                onClick: _ctx.save,
                disabled: !_ctx.isRoleValid || !_ctx.hasChanges
              }, null, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.newUser)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "sticky-button",
                icon: "pi pi-check",
                label: "Add new record",
                onClick: _ctx.saveNewUser,
                disabled: !_ctx.isRoleValid || !_ctx.hasChanges
              }, null, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}